<template>
	<div>
		<!-- 店铺详情 -->
		<cube-page title="使用条款和隐私政策">
			<div slot="content">
				<div class="main">
          <div @click="downloadFile" style="padding: 20px;color: #0a5ba6;font-size: 14px;">
            协议下载
          </div>
<!--					<pdf  v-for="i in numPages" :key="i"  :src="url" :page="i" ref="pdf"></pdf>-->
          <div v-if="content != null" style="white-space: pre-wrap;line-height: 25px;" v-html="content"></div>
				</div>
			</div>
		</cube-page>
	</div>
</template>

<script>
	import CubePage from '../../TP/cube-page.vue'
	import pdf from 'vue-pdf'
  import axios from "axios";
  import * as util from "@/utils/network";
	export default {
		components: {
			CubePage,
			pdf
		},
		data() {
			return {
				src: '',
				numPages: 1,
				pageTotalNum: 1,
				url:this.$route.params.url,
        content:null
			}
		},
		mounted() {
      this.getData();
			 // this.getNumPages(this.url)
		},
		methods: {
      getData() {
        let that = this
        var url = "/addons/litestore/api.account/getAgree"
        //这里直接调用网络接口
        util.get(url, {type:2},
            function(result) {
              that.content = result.data.content
              console.log(result.data)
            },
        );
      },
      downloadFile() {
        let that = this
        const a =document.createElement('a');
        a.setAttribute('download', '协议下载.pdf');
        a.download="协议下载.pdf";
        a.href=that.url;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);

      },
			getNumPages(url) {
				console.log(url)
				var loadingTask = pdf.createLoadingTask(url)
				this.url = loadingTask
				loadingTask.promise.then(pdf => {
					this.numPages = pdf.numPages
				}).catch((err) => {
					console.error('pdf加载失败')
				})
			}
		}
	}
</script>
<style type="text/css" lang="less">
	.main {
		.title {
			line-height: 45px;
			text-align: center;

		}

	.xieconten {
			padding: 15px;
			font-size: 12px;
		}
	}
</style>
